import axios from '@axios';

export default {
	namespaced: true,
	state: {},
	getters: {},
	mutations: {},
	actions: {
		fetchTenderWinner(ctx, { id }) {
			return new Promise((resolve, reject) => {
				axios
					.get(`/tender-winners/${id}/edit`)
					.then(response => resolve(response))
					.catch(error => reject(error));
			});
		},
		updateTenderWinner(ctx, { id, payload }) {
			return new Promise((resolve, reject) => {
				axios
					.put(`/tender-winners/${id}`, payload)
					.then(response => resolve(response))
					.catch(error => reject(error));
			});
		},
	}
}